(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/serversidehelper/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/app/serversidehelper/assets/javascripts/utils.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.app.ServerSideHelper.utils = {
    initView(view, region) {
      Marionette.monitorViewEvents(view);
      view.on('destroy', region._empty, region);
      view._parent = region;
      region.currentView = view;
      view._isServersideAttached = true;
      view.triggerMethod('attach:serverside');
    },

    attachView(region, view) {
      svs.app.ServerSideHelper.utils.initView(view, region);
      view.triggerMethod('serverside:initialized');
    }

  };
})(Backbone, _, svs);
 })(window);